import { ProgressContainer, ProgressFiller } from './Progressbar.styled'

export default function Progressbar({ completed }) {
  return (
    <ProgressContainer>
      <ProgressFiller completed={completed} />
    </ProgressContainer>
  )
}
